<template>
  <!-- 适配鸿蒙去掉width -->
  <div class="contrainer">
    <!-- <div class="contrainer" :style="isPc ? 'width:1100px' : ''"> -->
    <h1>网上老年大学用户协议</h1>
    <h2>1.确认并接受</h2>
    <p>
      1.1
      网上老年大学根据《网上老年大学用户服务协议》（以下简称"本协议"）为用户提供各类网站、APP、小程序或服务等（以下简称“本服务”）。“网上老年大学”是指深圳金龄时代科技有限公司及其相关服务可能存在的运营关联单位。涉及具体产品服务的，将由有资质的服务商提供。“用户”是指本服务的使用人，本协议也使用“您”来称呼用户。
    </p>
    <p>
      1.2
      当您使用网上老年大学某一具体网站频道、APP、产品、服务等具体服务时，您应遵守网上老年大学的与该具体服务相关的具体协议、指引和规则等。如《隐私政策》、《免责声明》等，前述所有的具体协议、指引、政策和声明及其网上老年大学已经发布的或将来可能发布的各类规则等，均构成本协议的一部分。除另行明确声明外，所有网上老年大学提供的服务均受本协议约束。
      若
      <span style="text-decoration: underline"
        >您作为网上老年大学的关联公司或合作公司、合作机构的用户登陆网上老年大学平台，访问网上老年大学网站或使用网上老年大学服务，即视为您同意本协议的所有条款及网上老年大学公布的其他规则、说明和操作指引。</span
      >
    </p>
    <p>
      1.3 您在使用本服务之前，应仔细阅读本协议以及相关具体协议。
      <span
        >本协议构成法律上的书面协议，本协议限制、免责条款、与您的权益（可能）存在重大关系的条款，已采用加粗字体来特别提醒您，请您留意重点查阅。除非您已阅读并接受本协议所有条款，否则您无权使用本服务。如您不同意本协议，或本协议全部或任何部分的修改，请您立即停止使用本服务。</span
      >
      <span
        >根据国家法律法规变化及网上老年大学运营需要，网上老年大学有权对本协议条款不时地进行修改，并根据国家法律法规的要求进行公示，修改后的协议在公示后生效并代替原来的协议。您应不时关注并阅读最新版的协议及网站公告。如您不同意更新后的新协议，您有权立即停止使用本服务。如您继续使用本服务，即视为完全同意更新后的协议。如果本协议中任何一条被司法或行政机关判定废止、无效或因任何理由不可执行，该条应视为可分的且并不影响任何其余条款的有效性和可执行性。</span
      >
    </p>
    <p>
      1.4
      <span>
        若用户未满18周岁则属于未成年人用户，未成年人用户请在监护人监护、指导下，阅读理解本协议，并特别注意未成年人使用条款。
        如果您未满18周岁，您需要在您的法定监护人陪同下使用本服务，否则网上老年大学将不能向您提供服务，因此给网上老年大学或第三方造成损失的，您须承担相应的赔偿责任。
      </span>
    </p>
    <p>
      如果您代表单位使用本服务，您确认，您已取得单位的合法书面授权来使用本网站。如果您不符合前述条件，网上老年大学将不能为您提供服务。因此给网上老年大学或者第三方造成损失的，您须承担相应的赔偿责任。
    </p>
    <h2>2.服务内容</h2>
    <p>
      2.1
      本服务的具体内容，由网上老年大学根据实际情况决定提供或不提供，例如：在网上老年大学网站及APP产品中发布视频、图文、话题、评论、上传图片或音视频等内容；发布并分享对资讯、话题、图片、音视频的评论（以下统称“内容”）。您理解并同意，本服务是按照现有技术和条件所能达到的现状提供的。网上老年大学会尽最大努力向您提供服务，确保服务的连贯性和安全性；但网上老年大学不能随时预见和防范法律、技术以及其他风险，包括但不限于不可抗力、病毒、木马、黑客攻击、系统不稳定、第三方服务瑕疵、政府行为等原因可能导致的服务中断、数据丢失以及其他的损失和风险。
      <span
        >对于任何用户信息或个人化设定之时效、删除、传递错误、未予储存或其它任何问题，网上老年大学均不承担任何责任。网上老年大学保留有权不经事先通知为升级、维护或其它目的暂停本服务全部或任何部分。</span
      >
    </p>
    <p>
      2.2网上老年大学依法为用户提供本服务，但是用户应对其使用网上老年大学自行承担责任及风险，网上老年大学在任何情况下不就因使用或不能使用网上老年大学提供的服务所发生的特殊的、意外的、直接或间接的损失承担赔偿责任。
    </p>
    <p>2.3网上老年大学会不定期通过站内积分，来奖励或兑换真实物品、权益。</p>
    <p>
      2.4请您理解，网上老年大学仅提供相关的网络服务，除此之外与相关网络服务有关的设备（如个人电脑、手机、及其他与接入互联网或移动网有关的装置）及所需的费用（如为接入互联网而支付的电话费及上网费、为使用移动网而支付的手机费）均应由用户自行负担。
      <span>您理解并同意，您使用本服务时会耗用您的终端设备和带宽等资源。</span>
    </p>
    <p>
      2.5
      <span
        >您理解并同意，除本服务协议另有规定外，鉴于网络服务的特殊性，网上老年大学有可能变更、中断或终止部分或全部的网络服务，网上老年大学无需为此承担责任，但网上老年大学应尽可能事先进行通知，并尽可能给您预留时间以便处理相关权益。</span
      >
    </p>
    <h2>3.用户使用基本规则</h2>
    <p>
      3.1
      您在使用网上老年大学的服务时可能需要注册一个账号。注册成功后，便成为网上老年大学的注册用户，会获得到一个账号，无需设置密码，通过验证码等方式验证登录。
      <span
        >您理解并接受网上老年大学对该账号的授权仅限于您个人、非商业、不可转让及非排他性的使用，网上老年大学保留该账号的所有权，并可以在必要时收回该账号，您仅可为访问或使用本服务的目的而使用该账号。网上老年大学特别提醒您应妥善保管您的帐号。当您使用完毕后，应安全退出。用户对利用该帐号所进行的一切活动负全部责任。</span
      >如果您的帐号遭到未授权的使用或发生其他任何安全问题，应立即通知网上老年大学。
    </p>
    <p>
      3.2为保护您的个人权益，在您使用手机号注册、实名认证、手机绑定等本服务时，您须对网上老年大学发送的校验码严格保密，您需承担因校验码泄露造成的损失。
    </p>
    <p>
      3.3
      您申请成为用户时，应向网上老年大学提供真实、准确、完整、合法有效的用户信息。当您的个人信息发生变动时，应及时通知网上老年大学进行更新。如果您提供的个人信息不真实、不准确、不完整，您须承担因此造成的责任及后果，网上老年大学保留法律允许范围内拒绝提供服务、删除您的用户帐户的权利。
    </p>
    <p>
      3.4您同意在使用本服务时遵守当地的相关法律法规的所有规定，并尊重当地的道德和风俗习惯。如您的行为违反当地法律法规或道德风俗，您应当为此独立承担责任。构成违法或犯罪的，将由您自行承担刑事责任。如果您违反了本条约定，相关国家机关或机构可能会对您提起诉讼、罚款或采取其他制裁措施，并要求网上老年大学给予协助的，网上老年大学可能会依法协助。如果您的违法行为造成网上老年大学损害的，您应依法予以赔偿。
    </p>
    <p>
      3.5用户可在使用本服务发布文字、图片、音视频及其他信息内容，但不得使用网上老年大学服务发送或传播敏感信息和违反国家法律法规政策的信息，此类信息包括但不限于：
    </p>
    <p>1）反对宪法所确定的基本原则的；</p>
    <p>2）危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；</p>
    <p>3）损害国家荣誉和利益的；</p>
    <p>4）煽动民族仇恨、民族歧视，破坏民族团结的；</p>
    <p>5）破坏国家宗教政策，宣扬邪教和封建迷信的；</p>
    <p>6）散布谣言，扰乱社会秩序，破坏社会稳定的；</p>
    <p>7）散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；</p>
    <p>8）侮辱或者诽谤他人，侵害他人合法权益的；</p>
    <p>9）含有法律、行政法规禁止的其他内容的。</p>
    <p>3.6用户禁止利用网上老年大学服务发布如下内容：</p>
    <p>
      1）含有色情、暴力、恐怖、不文明内容，包括但不限于：详细描写性器官、性行为和性心理，传播色情图片或其他色情内容，详细描写暴力行为过程和身心体验，详细描写恐怖事件和主观感受，引诱他人见面发生性关系或卖淫，雇佣、引诱他人从事暴力活动，恐吓他人，提供含有上述特点的链接等；
    </p>
    <p>
      2）含有人身攻击的内容，包括但不限于：诽谤他人，散布虚假信息，侵犯他人肖像权、隐私权等其他合法权益，用粗言秽语侮辱他人，造成身心伤害，损害社会团体或组织的名誉，提供含有上述内容的链接等；
    </p>
    <p>
      3）含有违规或未经网上老年大学允许的广告内容，包括但不限于：包含带有任何网络兼职、非真实性中奖信息的内容，包含带有任何职称代办、办证刻章、代写论文以及售卖考试答案等信息的内容，包含任何银行卡代办、买卖发票、非法彩票等信息的内容，以及未经网上老年大学允许的具有广告性质或广告嫌疑的词条、文字、图片或链接等。
    </p>
    <p>
      4）含有违背伦理道德的内容，包括但不限于：包含违反社会公共道德的内容，宣扬颓废、消极的人生观，劝诱自杀，描写自杀方法和过程，歧视和贬低弱势群体，如残疾、老龄和经济状况较差等，教授侵犯他人权益的方法，如黑客、诈骗等，宣传或劝诱不伦恋情、乱伦等违反伦常的行为，提供含有上述内容的链接等；
    </p>
    <p>5）其他侵权、违反法律法规、违背公序良俗，需要加以禁止的内容。</p>
    <p>3.7 用户在使用本服务过程中，还必须遵循以下原则：</p>
    <p>1） 遵守中国及所在国有关的法律和法规；</p>
    <p>
      2）用户不得侵任何人的知识产权，包括但不限于不得将侵犯任何人的专利、商标、著作权、商业秘密或其他专属权利；
    </p>
    <p>
      3）用户不得侵犯涉密信息，包括但不限于不得将无权传送的内容（例如商业秘密、内部资料、机密资料、个人信息等）进行上载、张贴、发送电子邮件或以其它方式发布、传送、传播、储存、或提供；
    </p>
    <p>
      4）用户不得为任何非法目的而使用网络服务系统，包括但不限于应当遵守法律法规，以及所有与网络服务有关的网络协议、规定和程序，不得利用网上老年大学网络服务系统进行任何可能对互联网的正常运转造成不利影响的行为，或其他任何非法行为；
    </p>
    <p>
      5）用户仅可在非商业范围内使用本服务。不得进行任何未经网上老年大学书面许可的商业广告行为，包括但不限于将广告函件、促销资料、垃圾邮件等，加以上载、张贴、发送电子邮件、发送站内信或以其它方式发布、传送、传播、储存，或提供；不得对网上老年大学上的任何数据作商业性利用，包括但不限于在未经网上老年大学事先书面同意的情况下，以复制、发布、传播等任何方式使用网上老年大学上展示的资料；
    </p>
    <p>
      6）用户不得利用本服务实施侵权行为，包括但不限于不得使用虚假、冒充他人或其他方的信息注册网上老年大学后发布评论或其他内容，不得冒充任何人或机构，或以虚伪不实的方式谎称或使人误认为其言论或身份与任何人或任何机构有关；不得伪造标题或以其它方式操控识别资料，使人误认为该内容为网上老年大学所传送；不得以虚构或歪曲事实的方式不当评价其他用户；不得利用网上老年大学网络服务系统传输任何骚扰性的、中伤他人的、辱骂性的、庸俗淫秽的或其他任何非法的信息资料；
    </p>
    <p>
      7）
      用户不得破坏本服务的提供，或侵犯本服务相关的任何权利，包括但不限于不得将有关干扰、破坏或限制任何计算机软件、硬件或通讯设备功能的软件病毒或其他计算机代码、档案和程序之资料，加以上载、张贴、发送电子邮件或以其它方式传送；不得采取任何将导致不合理的庞大数据负载加诸网上老年大学网络设备的行动；
    </p>
    <p>8）用户不得利用网络服务进行任何不利于网上老年大学的行为。</p>
    <p>
      3.8
      如用户违反本协议规定，网上老年大学有权在不通知用户的情况下删除用户发布的内容，严重违反上述规定的，网上老年大学有权单方取消对用户的服务。同时如果网上老年大学有理由认为用户的任何行为，包括但不限于用户的任何言论、账号、昵称或其它行为，违反或可能违反国家法律和法规的任何规定或影响到网上老年大学的利益，网上老年大学可在任何时候不经任何事先通知单方停止向用户提供服务，并无需对用户承担任何义务。
    </p>
    <p>
      3.9
      您在此承诺不经网上老年大学书面同意，不能利用本服务进行销售或开展其他商业性行为。如用户违反此约定，网上老年大学将依法追究您的违约责任，由此给网上老年大学造成损失的，网上老年大学有权主张损失赔偿，该等赔偿包括但不限于直接损失和可得利益损失。
    </p>
    <h2>4.用户隐私保护</h2>
    <p>
      4.1网上老年大学非常重视对用户个人信息的保护。网上老年大学将按照本协议及《隐私政策》的规定收集、使用、储存和分享您的个人信息。本协议对个人信息保护规定的内容与上述《隐私政策》有相冲突的，及本协议对个人信息保护相关内容未作明确规定的，均应以《隐私政策》的内容为准。
    </p>
    <p>
      4.2保护用户隐私是网上老年大学的一项基本政策，网上老年大学不对外公开或向第三方提供用户的注册资料及用户在使用网络服务时存储在网上老年大学的非公开内容，但下列情况除外：
    </p>
    <p>1）事先获得用户的明确授权；</p>
    <p>
      2）与国家安全、国防安全直接相关的；与公共安全、公共卫生、重大公共利益直接相关的；
    </p>
    <p>
      3）用于维护我们产品或服务的安全稳定运行所必需的，例如发现、处置产品或服务故障；
    </p>
    <p>
      4）出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；
    </p>
    <p>5）法律法规规定的其他情形。</p>
    <p>
      4.3 在以下（包括但不限于）几种情况下，网上老年大学有权使用用户的个人信息：
    </p>
    <p>
      1）
      某些情况下为进行相关商业合作需要调取用户的个人信息，该等情形包括但不限于在进行第三方产品促销或抽奖时，网上老年大学可能会与赞助商共享用户的个人信息，在这些情况下网上老年大学可能会在发送用户信息之前进行提示，您可以通过不参与来终止传送过程。
    </p>
    <p>2） 网上老年大学可能会将用户信息与第三方数据匹配。</p>
    <p>
      3）
      网上老年大学会披露用户统计数据，向未来的合作伙伴、广告商及其他第三方以及为了其他合法目的而描述公司的服务。在对用户隐私资料进行匿名化、去标识化处理的前提下，网上老年大学可对用户数据库进行分析并对用户数据库进行商业上合理范围内的利用。
    </p>
    <p>
      4）
      用户通过网上老年大学购买第三方（此处指“商家”）利用网上老年大学平台提供产品或服务时，网上老年大学获得的信息及用户提供的信息（例如用户的通讯信息等）会提供给商家，这些商家会进行数据收集、储存、使用等操作，但网上老年大学同样要求对商家收集、存储、使用数据应遵守网上老年大学《隐私政策》及本协议等网上老年大学规则，网上老年大学明确告知商家收集、存储、使用用户数据不当给用户造成损失的，商家承担赔偿等相关法律责任。
    </p>
    <p>
      4.4如您认为您的个人信息被网上老年大学超目的使用、或被其他用户侵权，请立即与网上老年大学联系，并按照要求提供相应的证明资料，网上老年大学将及时调查核实处理。
    </p>
    <h2>5.知识产权</h2>
    <p>
      5.1除法律法规明确规定，或另有明确协议约定之外，网上老年大学网站、APP、产品和服务所依托软件的著作权、专利权、网站架构、程序设计及其他相关权利归网上老年大学所有；网上老年大学使用的“网上老年大学”（文字）、（图形）以及其他注册商标、所有设计图样以及其他图样、产品、程序及服务名称等商业标识、商业名称，其著作权、商标权，或外观设计专利等权益归网上老年大学所有。上述知识产权均受到法律保护，未经网上老年大学书面许可，任何人不得以任何形式进行使用或创造相关衍生作品。
    </p>
    <p>
      5.2用户在网上老年大学上传或发布的内容，用户应保证其为著作权人或已取得相关权利人的合法授权，并且该内容不会侵犯任何第三方的合法权益，并保证该等内容具有准确性、真实性、正当性、合法性，且不得以任何形式侵犯第三人权益，因抄袭、转载、侵权等行为所产生的纠纷由用户自行解决，网上老年大学不承担任何法律责任。用户的内容侵犯了任何第三方的著作权或其他权利，第三方发出有效的权利通知时，网上老年大学有权在初步审核的基础上决定删除相关的内容。且网上老年大学有权在必要时配合第三方、司法机关或行政机关完成相关的取证，并根据法律、主管部门或司法部门的要求披露用户信息。
    </p>
    <p>
      5.3
      <span
        >对于用户在任何时间、任何地点通过移动终端等设备访问及/或使用网上老年大学及其关联网站、APP等产品或服务时发表的任何形式的文字、图片、音视频等知识产权信息，在法律规定的保护期限内用户免费授予网上老年大学获得全球非排他的许可使用权利及再授权给其他第三方使用并可以自身名义对第三方侵权行为进行维权，维权形式包括但不限于以发送侵权通告函件、提起诉讼、申请仲裁等方式。用户同意将其著作权非排他的授予网上老年大学该等权利包括但不限于：复制权、发行权、出租权、展览权、表演权、放映权、广播权、信息网络传播权、摄制权、改编权、翻译权、汇编权等可由著作权人转让的其他权益，该等授权覆盖网上老年大学现有服务以及未来任何时候提供的服务。同时，对于用户提供、发布及在网上老年大学服务中形成的除个人信息外的文字、图片、视频、音频等非个人信息，用户同意网上老年大学存储、使用、复制、修订、编辑、发布、展示、翻译、分发用户的非个人信息或制作其派生作品，并以已知或日后开发的形式、媒体或技术将上述信息纳入其它作品内。用户理解并确认，本服务协议已经构成《著作权法》第二十五条所规定的书面协议，其效力及于用户在网上老年大学网站、产品及服务等载体发布的任何受著作权法保护的作品内容，无论该内容形成于本协议签订前还是本协议签订后。无论用户以注册或不注册等方式使用网上老年大学的服务均视为已充分理解并完全同意本协议的条款，明确向网上老年大学作出上述许可。</span
      >
    </p>
    <p>
      5.4如用户希望网上老年大学停止使用或停止以某种方式使用其内容，用户可以向网上老年大学发出书面通知。
    </p>
    <p>
      5.5对于用户发表在网上老年大学小程序、APP的内容，任何人未经网上老年大学事先书面许可，禁止使用任何机器人、蜘蛛、其他自动设备，或手动程序来监视或复制网上老年大学小程序、APP中包含的任何内容。否则，网上老年大学有权依法追究法律责任。
    </p>
    <p>
      5.5
      【网上老年大学权利声明】用户在网上老年大学网站、APP中发布的文字、图片、音视频及其它内容，将受到法律的保护；该等文字、图片、音视频及其它内容用户享有著作权，未经网上老年大学或其他权利人书面授权许可，任何人不得进行修改、出租、散布或衍生其他作品，不得为任何非私人或商业目的获取或使用本网站的任何部分或通过本网站可直接或间接获得的任何内容、服务或资料。任何第三方违反本协议的规定以任何方式，和/或以任何文字对本网站的任何部分进行发表、复制、转载、更改、引用、链接、下载或以其它方式进行使用，或向任何其他第三方提供获取本网站任何内容的渠道，则对本网站的使用权将立即终止，且任何第三方必须按照本公司的要求，归还或销毁使用本网站任何部分的内容所创建的资料的任何副本。未经本协议明确允许而擅自使用本网站任何内容、服务或资料的，构成对本协议的违约行为，且可能触犯著作权、商标、专利和/或其他方面的法律法规。
    </p>
    <p>
      5.6网上老年大学不对用户发表的内容及其它附属品（如评论、话题、图片、音视频等）的正确性、客观性进行保证，用户发表的内容及其它附属品不代表网上老年大学观点和立场。
    </p>
    <h2>6.免责声明</h2>
    <p>
      6.1
      <span
        >网上老年大学是一个向广大用户提供信息存储空间服务的平台，网上老年大学上的部分信息来自于第三方或由用户的提供，且任何信息都存在滞后或会被更新的可能，因此网上老年大学不能保证在任何时候任何信息都准确无误。您应自行谨慎判断确定相关服务及/或信息的真实性、合法性和有效性，并自行承担因此产生的责任与损失。</span
      >
    </p>
    <p>
      6.2您理解并同意，
      <span
        >网上老年大学提供的产品和服务涉及到互联网及移动通讯等服务，可能会受到各个环节不稳定因素的影响。因此因不可抗力、计算机病毒或黑客攻击、系统不稳定、用户所在位置、用户关机、互联网络、通信线路等其他网上老年大学无法预测或控制的原因，造成服务中断、取消或终止的风险，由此给您带来的损失网上老年大学不承担赔偿责任。</span
      >
    </p>
    <p>
      6.3
      <span
        >网上老年大学不保证，包括但不限于：本服务适合用户的使用要求；本服务不受干扰，及时、安全、可靠或不出现错误。</span
      >
    </p>
    <h2>7.关于第三方提供的服务</h2>
    <p>7.1本服务可能会提供与其他网站或资源进行链接。</p>
    <p>
      7.2您在网上老年大学平台上使用第三方提供的产品或服务时，除遵守本协议约定外，还应遵守第三方的服务或用户协议。网上老年大学和第三方对可能出现的纠纷在法律规定和约定的范围内各自承担责任。
    </p>
    <p>
      7.3健康服务-健康生活，指经网上老年大学筛选，产品、服务具备一定优势的服务提供方集合。
    </p>
    <p>
      7.4服务提供方，指与网上老年大学合作，为网上老年大学用户实际提供产品及服务的主体。
    </p>
    <h2>8.国际使用之特别敬告</h2>
    <p>
      您已了解国际互联网具有跨越国界浏览的特点，同意遵守当地所有关于网上行为及内容之法律法规。您特别同意遵守有关中国或您所在国家或地区关于互联网信息传播相关的所有法律法规。
    </p>
    <h2>9.赔偿</h2>
    <p>
      9.1
      由于您在使用、影响使用、或利用本服务实施任何违法、违规、违反本协议的行为，造成任何损失，均包括直接损失及可得利益损失，以及相关人士为维权而发生的调查、取证费用损失、以及律师费损失等相关维权损失。
    </p>
    <p>
      9.2您保证不以任何形式侵犯网上老年大学及其分公司、子公司、关联企业、以及该等机构之高级职员、代理人、品牌共有人或其它合作伙伴及员工的权益，并使其免受损害，并承诺全面承担由此引发的全部法律责任。
    </p>
    <h2>10.终止服务</h2>
    <p>
      <span
        >您同意网上老年大学基于其自行之考虑，因任何理由终止本服务，具体原因包含但不限于缺乏使用，或网上老年大学认为您已经违反本协议的文字及精神等方面。</span
      >
    </p>
    <h2>11.法律的适用和管辖</h2>
    <p>
      11.1本协议的成立、生效、履行、解释及纠纷解决，均受到中华人民共和国大陆地区法律（不包含冲突法）法律管辖。用户和网上老年大学一致同意服从法院的管辖。若有任何服务条款与法律相抵触（下称“待定条款”），待定条款将按尽可能接近的方法重新解析，而其它条款则保持对用户产生法律效力和影响，因用户解释本服务协议或通过网上老年大学预订任何产品而导致的争议，应首先友好协商解决，协商不成时，应将纠纷或争议提请网上老年大学所在地有管辖权的法院管辖。
    </p>
    <p>
      11.2
      网上老年大学未行使或执行本协议任何权利或利益，不构成对前述权利或利益之放弃。
    </p>
  </div>
</template>

<script>
export default {
  name: "Xieyi",
  data() {
    return {
      isPc: true,
    };
  },
  mounted() {
    this.isPc = this.modoule();
  },
  methods: {
    modoule() {
      var userAgentInfo = navigator.userAgent;
      var Agents = new Array(
        "Android",
        "iPhone",
        "SymbianOS",
        "Windows Phone",
        "iPad",
        "iPod",
      );
      var flag = true;
      for (var v = 0; v < Agents.length; v++) {
        if (userAgentInfo.indexOf(Agents[v]) > 0) {
          flag = false;
          break;
        }
      }
      return flag;
    },
  },
};
</script>

<style lang="scss" scoped>
.contrainer {
  padding: 20px;
  padding-top: 0;
  margin: 0 auto;
}
h1 {
  font-size: 16pt;
  font-family:
    PingFangSC-Medium,
    PingFang SC;
  font-weight: 700;
  color: black;
  line-height: 16.5pt;
  text-align: center;
  margin-top: 20px;
  margin-bottom: 20px;
}
h2 {
  font-size: 15pt;
  font-family:
    PingFangSC-Medium,
    PingFang SC;
  font-weight: 600;
  color: black;
  line-height: 16.5pt;
  margin: 10px 0;
}
h3 {
  font-size: 15pt;
  font-family:
    PingFangSC-Medium,
    PingFang SC;
  font-weight: 500;
  color: black;
  line-height: 16.5pt;
  margin: 10px 0;
}
p {
  font-size: 12.5pt;
  font-family:
    PingFangSC-Regular,
    PingFang SC;
  font-weight: 400;
  color: black;
  line-height: 18.5pt;
  text-align: justify;
  text-indent: 2.66vw;
  span {
    font-weight: 600;
  }
}
</style>
